import styled from 'styled-components';

const HeaderWrapper = styled.header`
  padding: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  letter-spacing: 0.1em;
`;

export const Header = () => (
  <HeaderWrapper>
        <Title>DocDah</Title>
  </HeaderWrapper>
);
